// src/config/api.js
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://mwa-backend-production.up.railway.app/api/v1',
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
};

export const ENDPOINTS = {
  CART: '/cart/',
  CLASSES: '/classes/',
  EVENTS: '/events/',
  BLOG: '/blog/',
  CONTACT: '/contact/',
  AUTH: '/auth',
  STORE: '/store/',
  HEALTH: '/health/',
  REGISTRATIONS: '/registrations/',
  TESTIMONIALS: '/testimonials/',
  USERS: '/users/',
  PAYMENTS: '/payment',
  ORDERS: '/orders',
};

export const STORAGE_URLS = {
  CMS_MEDIA: 'https://tuawsutyaghffawpyaoh.supabase.co/storage/v1/object/public/cms-media',
  INTRO_VIDEO_BASE: 'https://pub-3e6e3c991f4b4e0c912fe3c1b628f357.r2.dev',
}; 